export default __webpack_public_path__ + "static/logo_header-328595af32bea1d36ac847e398378ef5.svg";